import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=25a5a080&scoped=true&lang=pug"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"
import style0 from "./Team.vue?vue&type=style&index=0&id=25a5a080&prod&scoped=true&lang=css"
import style1 from "./Team.vue?vue&type=style&index=1&id=25a5a080&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a5a080",
  null
  
)

export default component.exports